import { Pipe, PipeTransform } from '@angular/core';
import { SituationPersonnelle } from '@lib/models/generated/graphql';

@Pipe({
  name: 'maritalStatus',
})
export class MaritalStatusPipe implements PipeTransform {
  transform(situationPersonnelle: SituationPersonnelle | undefined | null): string {
    if (!situationPersonnelle) {
      return 'non renseigné';
    }
    const maritalStatus = situationPersonnelle.etatCivilTypeLibelle ?? 'Non renseigné';

    if (situationPersonnelle.etatCivilTypeCode === 'MARIE') {
      const regime = situationPersonnelle.etatCivilTypeRegimeLibelle ?? 'Non renseigné';
      return `${maritalStatus} - ${regime}`;
    }

    return maritalStatus;
  }
}
